<script setup>
import { usePlaylistStore } from "@/stores/playlist.js";
import { enableScroll, disableScroll, scrollToSlide } from "@/Helpers/scroll";
import { ref, onMounted, watch, onBeforeMount, getCurrentInstance } from 'vue';

const props = defineProps({
    row: {
        type: Object,
        default: undefined,
    },
    playlistId: {
        type: Number,
        default: undefined,
    },
    isIntersecting: Boolean,
    scormExport: Boolean,
})

const store = usePlaylistStore();
const instance = getCurrentInstance();
const isAnswered = ref(false);
const textAreaInput = ref(null);
const errorMessage = ref(null);
const requireAnswer = ref(true);

const firstPathSegment = window.location.pathname.split('/')[1];

const scormApi = ref(null);
if (props.scormExport) {
    scormApi.value = instance.appContext.config.globalProperties.$scorm.api;
}

watch(
    () => props.isIntersecting,
    (newVal, oldVal) => {
        if (props.isIntersecting === true && isAnswered.value === false) {
            if (requireAnswer.value) disableScroll();
        } else if (props.isIntersecting === true && isAnswered.value === true) {
            enableScroll();
        }
        if (newVal === false && oldVal === true) {
            enableScroll();
        }
    }
);

function setPreviousAnswer() {
    const answer = store.getPreviousReflection(props.row.id);
    if (answer) {
        textAreaInput.value.value = answer;
        isAnswered.value = true;
        enableScroll();
    }
}

onBeforeMount(() => {
    if (props.row.content.requireAnswer === 0 || props.row.content.requireAnswer === false || props.row.content.requireAnswer === 'false') {
        requireAnswer.value = false;
    } else {
        requireAnswer.value = true;
    }
});

onMounted(() => {
    setPreviousAnswer()
});

function checkTextInput() {
    errorMessage.value = null;
    if (textAreaInput.value.value === '') {
        errorMessage.value = 'Please enter a response';
        return;
    }

    saveReflection(props.row.content.question, textAreaInput.value.value);
}

function moveToNextSlide() {
    isAnswered.value = true;
    enableScroll();
    if (props.row.content.autoSkip === 'true') {
        scrollToSlide(store.currentSlideIndex + 1);
    }
}

function saveReflection(strQuestion, strAnswer) {

    if (firstPathSegment === 'preview' || firstPathSegment === 'admin') {
        moveToNextSlide();
        return;
    };

    const data = {
        playlist_id: props.playlistId,
        playlist_card_row_id: props.row.id,
        question: strQuestion,
        answer: strAnswer,
    }

    if (props.scormExport && scormApi.value) {
        scormApi.value.recordInteraction(data);
        moveToNextSlide();
    } else {
        const url = '/activity/store_reflection'
        axios.post(url, data)
            .then(function (response) {
                moveToNextSlide();
            })
            .catch(function (error) {
                // do nothing
            });
    }
}
</script>
<template>
    <div class="relative p-fl-4 w-full">
        <div v-if="row.content.question !== '' && row.content.question" class="font-black text-fl-lg w-full pb-fl-2">
            {{ row.content.question }} <sup v-if="requireAnswer" class="text-red-700">*</sup>
        </div>
        <textarea ref="textAreaInput" class="w-full text-platform-black" rows="3" :placeholder="row.content.placeholder" :disabled="isAnswered" />
        <div v-if="errorMessage" class="text-red-500 text-sm">
            {{ errorMessage }}
        </div>
        <div v-if="!isAnswered" class="flex flex-col w-full">
            <button
                type="button"
                class="place-self-end rounded-full
                px-fl-4
                py-fl-2
                font-bold
                shadow-sm
                border-2
                focus-visible:outline
                focus-visible:outline-2
                focus-visible:outline-offset-2
                focus-visible:outline-white"
                @click="checkTextInput"
            >
                Submit
            </button>
        </div>
    </div>
</template>

<style scoped>
button, li {
    border-color: var(--button_bg);
    background-color: var(--button_bg);
    color: var(--button_text);
}

button:hover, li:hover {
    background-color: var(--button_hover_bg);
    color: var(--button_hover_text);
}

textarea {
    border: 2px solid var(--button_bg);
    border-radius: 0.5rem;
    padding: 0.5rem;
}
</style>
